import { SCORE } from './calculateScore';

export const scoreLabel: {
  [score: number]: string;
} = {
  [SCORE.none]: 'none',
  [SCORE.low]: 'low',
  [SCORE.medium]: 'medium',
  [SCORE.high]: 'high',
};
